import { render, staticRenderFns } from "./BulldozerBig.vue?vue&type=template&id=63ef7d00"
import script from "./BulldozerBig.vue?vue&type=script&lang=js"
export * from "./BulldozerBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports